// extracted by mini-css-extract-plugin
module.exports = {"CaptchaCheckbox__error":"captcha-checkbox_CaptchaCheckbox__error__zlyaf"};